var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "unified-navigation-ui": "static-1.26939",
      "ably-hubspot-js": "static-2.3472",
      "breadcrumbs-ui": "static-1.2125",
      "client-types": "static-1.376",
      "enviro": "static-4.306",
      "head-dlb": "static-1.4043",
      "hs-lodash": "static-4.45",
      "hs-promise-utils": "static-1.4435",
      "hs-test-utils": "static-1.6907",
      "hub-http": "static-1.4807",
      "hubspot-url-utils": "static-1.3234",
      "HubStyleTokens": "static-2.10408",
      "I18n": "static-7.1394",
      "jasmine-runner": "static-1.5309",
      "nav-client-types": "static-1.1237",
      "nav-meta": "static-1.25732",
      "navigation-components": "static-1.14095",
      "navigation-components-tests": "static-1.10705",
      "navigation-messaging": "static-1.3422",
      "quartz": "static-1.5652",
      "react": "static-7.151",
      "react-dnd": "static-2.33",
      "react-dnd-html5-backend": "static-2.10",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "rpc-client-utils": "static-1.3615",
      "target-element-observer": "static-1.1126",
      "trials-service-types": "static-1.3002",
      "webpack-env": "static-1.54",
      "wootric-nps": "static-1.5809",
      "ably": "static-2.2",
      "calling-internal-common": "static-1.30134",
      "classnames": "static-2.10",
      "crosstab": "static-1.3522",
      "ExtensionInstallHelpers": "static-1.539",
      "foundations-assets": "static-1.3816",
      "foundations-components": "static-1-7234-button-link-children-spacing.30",
      "foundations-theming": "static-1.3214",
      "foundations-theming-base": "static-1.2199",
      "foundations-theming-specialty": "static-1.931",
      "frontend-preferences-client": "static-1.6784",
      "global-search-externals": "static-1.11783",
      "idb-keyval": "static-1.21",
      "magpie-lib": "static-1.4559",
      "magpie-types": "static-1.4019",
      "metrics-js": "static-1.8667",
      "nav-onboarding-tours": "static-1.2406",
      "notification-sounds": "static-1.3334",
      "prefetcher": "static-1.4666",
      "react-dom": "static-7.85",
      "react-utils": "static-2.4405",
      "redux-thunk": "static-2.43",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.7070",
      "simple-logging-lib": "static-1.1935",
      "styled-components": "static-2.64",
      "superstore": "static-1.3669",
      "trial-components-library": "static-1.11094",
      "ts-schema": "static-1.3214",
      "ui-images": "static-2.868",
      "usage-tracker-core": "static-1.6220",
      "hs-promise-rejection-tracking": "static-1.4356",
      "PortalIdParser": "static-2.284",
      "raven": "static-3.4818",
      "raven-hubspot": "static-1.5125",
      "bend-plugin-trellis-migration": "static-1.2527",
      "moment": "static-3.26",
      "quartz-core": "static-1.4871",
      "storybook-react": "static-1.4",
      "HeadJS": "static-2.580",
      "framer-motion": "static-1.41",
      "hs-test-utils-bend-plugin": "static-1.2018",
      "msw": "static-1.39",
      "testing-library": "static-1.121",
      "i18n-data": "static-1.198",
      "moment-timezone": "static-5.51",
      "jasmine": "static-4.3242",
      "quartz-core-utils": "static-1.2519",
      "StyleGuideUI": "static-3.464",
      "csstype": "static-1.38",
      "hoist-non-react-statics": "static-3.9",
      "quick-fetch": "static-1.2772",
      "HubStyle": "static-2.10716",
      "calling-error-reporting": "static-1.30140",
      "calling-usage-tracker": "static-1.5394",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "self-service-api": "static-1.9105",
      "SharedI18nStrings": "static-1.162",
      "UIComponents": "static-3.7355",
      "hs-story-utils": "static-1.8279",
      "bend-plugin-foundations-components": "static-1-7234-button-link-children-spacing.30",
      "floating-ui": "static-1.29",
      "react-aria": "static-1.39",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.74",
      "tanstack-table": "static-1.23",
      "ui-fonts": "static-1.332",
      "bend-plugin-foundations-theming": "static-1.1697",
      "hub-http-janus": "static-1.652",
      "global-search-shared": "static-1.12498",
      "usage-tracker": "static-1.6370",
      "autolinker": "static-3.11",
      "sanitize": "static-1.3276",
      "transmute": "static-2.29",
      "ai-components-ui-library": "static-1.5375",
      "atom": "static-1.4088",
      "copilot-toolkit": "static-1.6846",
      "demographics-client": "static-1.4326",
      "hubs-service-types": "static-1.373",
      "icons": "static-2.592",
      "laboratory-lib": "static-3.6142",
      "onboarding-scopes": "static-1.5461",
      "react-input-autosize": "static-2.17",
      "salesImages": "static-1.501",
      "signup-constants": "static-1.16480",
      "ui-addon-i18n": "static-1.9811",
      "ui-addon-upgrades": "static-9.16156",
      "user-context": "static-1.4085",
      "dispatcher": "static-1.113",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-shared-msw-handlers": "static-1.7180",
      "hubspotter-http": "static-1.3656",
      "hubspotter-http-shared-msw-handlers": "static-1.7178",
      "mobile-manifest-mixins": "static-1.351",
      "platform-navigation-bootstrap": "static-1.11323",
      "react-rhumb": "static-1.15474",
      "react-router-dom": "static-5.26",
      "cssUtils": "static-1.520",
      "customer-data-ui-utilities": "static-1.8621",
      "ai-addon-copilot-preview": "static-1.4587",
      "apollo-link-hub-http": "static-2.3666",
      "apollo-stack-hubspot": "static-3.43",
      "data-fetching-client": "static-1.8525",
      "graphql": "static-1.59",
      "search-service-types": "static-1.2862",
      "chatspot-client-types": "static-1.8777",
      "chatspot-core": "static-1.16137",
      "ContentUtils": "static-1.63702",
      "sassPrefix": "static-1.132",
      "foundations-components-test-utils": "static-1-7234-button-link-children-spacing.30",
      "feature-store-service-types": "static-1.3594",
      "growth-monetization-service-types": "static-1.3601",
      "upgrade-management-service-types": "static-1.3585",
      "getting-started-shared-tasks": "static-1.13232",
      "getting-started-shared-tasks-store": "static-1.12350",
      "platform-infra-nav-components": "static-1.6776",
      "react-dnd-compat": "static-1.3558",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "ai-settings-ui-library": "static-1.6032",
      "apollo-dlb": "static-3.41",
      "markdown-it": "static-1.6",
      "fast-json-stable-stringify": "static-1.4",
      "cms-field-types": "static-1.3686",
      "content-icons-ui": "static-1.1930",
      "underscore": "static-1.8",
      "ui-addon-avatars": "static-2.8157",
      "ui-addon-react-router-dom": "static-1.8507",
      "usage-tracker-container": "static-1.6360"
    },
    "depPathPrefixes": {
      "unified-navigation-ui": "/unified-navigation-ui/static-1.26939",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3472",
      "breadcrumbs-ui": "/breadcrumbs-ui/static-1.2125",
      "client-types": "/client-types/static-1.376",
      "enviro": "/enviro/static-4.306",
      "head-dlb": "/head-dlb/static-1.4043",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hs-promise-utils": "/hs-promise-utils/static-1.4435",
      "hs-test-utils": "/hs-test-utils/static-1.6907",
      "hub-http": "/hub-http/static-1.4807",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3234",
      "HubStyleTokens": "/HubStyleTokens/static-2.10408",
      "I18n": "/I18n/static-7.1394",
      "jasmine-runner": "/jasmine-runner/static-1.5309",
      "nav-client-types": "/nav-client-types/static-1.1237",
      "nav-meta": "/nav-meta/static-1.25732",
      "navigation-components": "/navigation-components/static-1.14095",
      "navigation-components-tests": "/navigation-components-tests/static-1.10705",
      "navigation-messaging": "/navigation-messaging/static-1.3422",
      "quartz": "/quartz/static-1.5652",
      "react": "/react/static-7.151",
      "react-dnd": "/react-dnd/static-2.33",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "rpc-client-utils": "/rpc-client-utils/static-1.3615",
      "target-element-observer": "/target-element-observer/static-1.1126",
      "trials-service-types": "/trials-service-types/static-1.3002",
      "webpack-env": "/webpack-env/static-1.54",
      "wootric-nps": "/wootric-nps/static-1.5809",
      "ably": "/ably/static-2.2",
      "calling-internal-common": "/calling-internal-common/static-1.30134",
      "classnames": "/classnames/static-2.10",
      "crosstab": "/crosstab/static-1.3522",
      "ExtensionInstallHelpers": "/ExtensionInstallHelpers/static-1.539",
      "foundations-assets": "/foundations-assets/static-1.3816",
      "foundations-components": "/foundations-components/static-1-7234-button-link-children-spacing.30",
      "foundations-theming": "/foundations-theming/static-1.3214",
      "foundations-theming-base": "/foundations-theming-base/static-1.2199",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.931",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.6784",
      "global-search-externals": "/global-search-externals/static-1.11783",
      "idb-keyval": "/idb-keyval/static-1.21",
      "magpie-lib": "/magpie-lib/static-1.4559",
      "magpie-types": "/magpie-types/static-1.4019",
      "metrics-js": "/metrics-js/static-1.8667",
      "nav-onboarding-tours": "/nav-onboarding-tours/static-1.2406",
      "notification-sounds": "/notification-sounds/static-1.3334",
      "prefetcher": "/prefetcher/static-1.4666",
      "react-dom": "/react-dom/static-7.85",
      "react-utils": "/react-utils/static-2.4405",
      "redux-thunk": "/redux-thunk/static-2.43",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.7070",
      "simple-logging-lib": "/simple-logging-lib/static-1.1935",
      "styled-components": "/styled-components/static-2.64",
      "superstore": "/superstore/static-1.3669",
      "trial-components-library": "/trial-components-library/static-1.11094",
      "ts-schema": "/ts-schema/static-1.3214",
      "ui-images": "/ui-images/static-2.868",
      "usage-tracker-core": "/usage-tracker-core/static-1.6220",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4356",
      "PortalIdParser": "/PortalIdParser/static-2.284",
      "raven": "/raven/static-3.4818",
      "raven-hubspot": "/raven-hubspot/static-1.5125",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2527",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.4871",
      "storybook-react": "/storybook-react/static-1.4",
      "HeadJS": "/HeadJS/static-2.580",
      "framer-motion": "/framer-motion/static-1.41",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2018",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.121",
      "i18n-data": "/i18n-data/static-1.198",
      "moment-timezone": "/moment-timezone/static-5.51",
      "jasmine": "/jasmine/static-4.3242",
      "quartz-core-utils": "/quartz-core-utils/static-1.2519",
      "StyleGuideUI": "/StyleGuideUI/static-3.464",
      "csstype": "/csstype/static-1.38",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "HubStyle": "/HubStyle/static-2.10716",
      "calling-error-reporting": "/calling-error-reporting/static-1.30140",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.5394",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "self-service-api": "/self-service-api/static-1.9105",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
      "UIComponents": "/UIComponents/static-3.7355",
      "hs-story-utils": "/hs-story-utils/static-1.8279",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-7234-button-link-children-spacing.30",
      "floating-ui": "/floating-ui/static-1.29",
      "react-aria": "/react-aria/static-1.39",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.74",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-fonts": "/ui-fonts/static-1.332",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1697",
      "hub-http-janus": "/hub-http-janus/static-1.652",
      "global-search-shared": "/global-search-shared/static-1.12498",
      "usage-tracker": "/usage-tracker/static-1.6370",
      "autolinker": "/autolinker/static-3.11",
      "sanitize": "/sanitize/static-1.3276",
      "transmute": "/transmute/static-2.29",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.5375",
      "atom": "/atom/static-1.4088",
      "copilot-toolkit": "/copilot-toolkit/static-1.6846",
      "demographics-client": "/demographics-client/static-1.4326",
      "hubs-service-types": "/hubs-service-types/static-1.373",
      "icons": "/icons/static-2.592",
      "laboratory-lib": "/laboratory-lib/static-3.6142",
      "onboarding-scopes": "/onboarding-scopes/static-1.5461",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "salesImages": "/salesImages/static-1.501",
      "signup-constants": "/signup-constants/static-1.16480",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.9811",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.16156",
      "user-context": "/user-context/static-1.4085",
      "dispatcher": "/dispatcher/static-1.113",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7180",
      "hubspotter-http": "/hubspotter-http/static-1.3656",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7178",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.351",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11323",
      "react-rhumb": "/react-rhumb/static-1.15474",
      "react-router-dom": "/react-router-dom/static-5.26",
      "cssUtils": "/cssUtils/static-1.520",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8621",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.4587",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3666",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
      "data-fetching-client": "/data-fetching-client/static-1.8525",
      "graphql": "/graphql/static-1.59",
      "search-service-types": "/search-service-types/static-1.2862",
      "chatspot-client-types": "/chatspot-client-types/static-1.8777",
      "chatspot-core": "/chatspot-core/static-1.16137",
      "ContentUtils": "/ContentUtils/static-1.63702",
      "sassPrefix": "/sassPrefix/static-1.132",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1-7234-button-link-children-spacing.30",
      "feature-store-service-types": "/feature-store-service-types/static-1.3594",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3601",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3585",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.13232",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.12350",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6776",
      "react-dnd-compat": "/react-dnd-compat/static-1.3558",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.6032",
      "apollo-dlb": "/apollo-dlb/static-3.41",
      "markdown-it": "/markdown-it/static-1.6",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "cms-field-types": "/cms-field-types/static-1.3686",
      "content-icons-ui": "/content-icons-ui/static-1.1930",
      "underscore": "/underscore/static-1.8",
      "ui-addon-avatars": "/ui-addon-avatars/static-2.8157",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8507",
      "usage-tracker-container": "/usage-tracker-container/static-1.6360"
    },
    "project": "unified-navigation-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};